import { fetchAPI } from '@helpers/fetch';

export async function serviceResultDragonByGame(gameCode, brand) {
  return fetchAPI(
    `result/service/mobile/results/dragon/${gameCode}?brand=${
      brand || 'guest'
    }&limit=30`,
  );
}
